import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { NowcastingNotifier } from './nowcasting-notifier';
import { NowcastingState } from './nowcasting-state';

@Injectable()
export class NowcastingProvider extends BaseProvider<NowcastingNotifier, NowcastingState> {
  constructor() {
    super(NowcastingNotifier);
  }
}
